<script setup>
import { computed } from 'vue'
import { usePortalStore } from '@/store/portal'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import SupportFrame from '@/components/portal/SupportFrame.vue'
import InquiryPanel from '../common/components/InquiryPanel.vue'
const route = useRoute(), portal = usePortalStore(), auth = useAuthStore(), kind = computed(() => route.path === '/support/qna' ? 'QNA' : 'INQUIRY'), page = computed(() => portal.pageOf(route.meta.portalPage))
useHead(() => ({ title: `${page.value?.title || '문의'} · TECHEDU` }))
</script>
<template><SupportFrame :title="page?.title || '문의'" :group="page?.group || '학습지원센터'" :parent="page?.parent || '/support'"><InquiryPanel :key="kind" :auth="auth.client" area="user" :kind="kind" :session="auth.member" /></SupportFrame></template>
